import { Component, OnInit } from '@angular/core';

import { EnvironmentService } from '@library/core/services';

import { NavMenuService, NavItem } from '@library/modules/menu';
export const MenuItems: NavItem[] = [
   { label: 'Shipments',       path: '/shipments',    icon: 'shipments',      access: 'tracking'  },
   { label: 'Create Shipment', path: '/shipment',     icon: 'createshipment', access: 'booking'   },
   { label: 'Templates',       path: '/template',     icon: 'templates',      access: 'booking'   },
   { label: 'Invoices',        path: '/invoice',      icon: 'invoices',       access: 'invoicing' },
   { label: 'Reports',         path: '/report',       icon: 'reports',        access: 'tracking'  },
   { label: 'Activity Feed',   path: '/activityfeed', icon: 'activityfeed',   access: 'tracking'  },
   { label: 'Address Book',    path: '/addressbook',  icon: 'addressbook',    access: 'booking'   },
   // { label: 'Admin',           path: '/admin',        icon: 'admin',          access: 'admin' },
];

@Component({
   selector: 'app-menu',
   templateUrl: './menu.component.html',
   styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
   constructor(
      private nav: NavMenuService,
      public environment: EnvironmentService,
   ) {}

   ngOnInit(): void {
      this.nav.load( MenuItems );
      this.nav.showTracking = true;
      this.nav.title = '4pl portal';
   }
}
